import {
  BookMarked,
  CalendarRange,
  CalendarClock,
  CalendarOff,
  ClipboardCheck,
  FilePen,
  FileSpreadsheet,
  GraduationCap,
  type LucideIcon,
  Megaphone,
  MessagesSquare,
  MonitorPlay,
  Wallet,
} from 'lucide-react'

/** Optional modules a platform operator turns on or off per school (the rest is the core). */
export const SCHOOL_MODULES = [
  'attendance',
  'timetable',
  'exams',
  'leave',
  'finance',
  'library',
  'announcements',
  'imports',
  'lms',
  'messaging',
  'courses',
  'admissions',
] as const
export type SchoolModuleKey = (typeof SCHOOL_MODULES)[number]

/** English labels and descriptions (translated with tAny / the "platform" namespace). */
export const SCHOOL_MODULE_META: Record<
  SchoolModuleKey,
  { label: string; description: string; icon: LucideIcon }
> = {
  attendance: {
    label: 'Attendance',
    description: 'Daily registers, holidays, monthly overview, family view.',
    icon: ClipboardCheck,
  },
  timetable: {
    label: 'Timetable',
    description: 'Weekly class timetables and substitute cover; decides who teaches what.',
    icon: CalendarClock,
  },
  exams: {
    label: 'Examinations',
    description: 'Exams, marks entry, results and report cards.',
    icon: GraduationCap,
  },
  leave: {
    label: 'Leave',
    description: 'Staff leave and student absence requests with approval.',
    icon: CalendarOff,
  },
  finance: {
    label: 'Finance',
    description: 'Fees, invoices, payments, receipts and reports.',
    icon: Wallet,
  },
  library: {
    label: 'Library',
    description: 'Catalogue, loans, returns and fines.',
    icon: BookMarked,
  },
  announcements: {
    label: 'Announcements',
    description: 'Notices to staff and families, with read receipts.',
    icon: Megaphone,
  },
  imports: {
    label: 'Data import',
    description: 'Admit students in bulk from a CSV file.',
    icon: FileSpreadsheet,
  },
  lms: {
    label: 'Online learning',
    description: 'Lessons and resources online, homework handed in and graded.',
    icon: MonitorPlay,
  },
  messaging: {
    label: 'Messaging and calls',
    description: 'Conversations, class rooms, and audio or video calls between staff, students and families.',
    icon: MessagesSquare,
  },
  courses: {
    label: 'Course catalogue',
    description: 'Predefined courses scheduled for each group with their own dates and weekly sessions.',
    icon: CalendarRange,
  },
  admissions: {
    label: 'Online admissions',
    description: 'Public application form, review by the school office and placement in a section.',
    icon: FilePen,
  },
}

/** Schools created before modules existed send no list: everything is on. */
export function moduleEnabled(modules: readonly string[] | undefined, key: SchoolModuleKey): boolean {
  return modules === undefined || modules.includes(key)
}
